module.exports = __webpack_public_path__ + "static/media/editIcon.c2347c81.svg";